"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = require("./color");
var Bluebird = require("bluebird");
var defaults = require("lodash/defaults");
var builder_1 = require("./builder");
var Util = require("./util");
var Quantizer = require("./quantizer");
var Generator = require("./generator");
var Filters = require("./filter");
var Vibrant = /** @class */ (function () {
    function Vibrant(_src, opts) {
        this._src = _src;
        this.opts = defaults({}, opts, Vibrant.DefaultOpts);
        this.opts.combinedFilter = Filters.combineFilters(this.opts.filters);
    }
    Vibrant.from = function (src) {
        return new builder_1.default(src);
    };
    Vibrant.prototype._process = function (image, opts) {
        var quantizer = opts.quantizer, generator = opts.generator;
        image.scaleDown(opts);
        return image.applyFilter(opts.combinedFilter)
            .then(function (imageData) { return quantizer(imageData.data, opts); })
            .then(function (colors) { return color_1.Swatch.applyFilter(colors, opts.combinedFilter); })
            .then(function (colors) { return Bluebird.resolve(generator(colors)); });
    };
    Vibrant.prototype.palette = function () {
        return this.swatches();
    };
    Vibrant.prototype.swatches = function () {
        return this._palette;
    };
    Vibrant.prototype.getPalette = function (cb) {
        var _this = this;
        var image = new this.opts.ImageClass();
        return image.load(this._src)
            .then(function (image) { return _this._process(image, _this.opts); })
            .tap(function (palette) { return _this._palette = palette; })
            .finally(function () { return image.remove(); })
            .asCallback(cb);
    };
    Vibrant.Builder = builder_1.default;
    Vibrant.Quantizer = Quantizer;
    Vibrant.Generator = Generator;
    Vibrant.Filter = Filters;
    Vibrant.Util = Util;
    Vibrant.DefaultOpts = {
        colorCount: 64,
        quality: 5,
        generator: Generator.Default,
        ImageClass: null,
        quantizer: Quantizer.MMCQ,
        filters: [Filters.Default]
    };
    return Vibrant;
}());
exports.default = Vibrant;
//# sourceMappingURL=vibrant.js.map


//////////////////
// WEBPACK FOOTER
// ./~/node-vibrant/lib/vibrant.js
// module id = 244
// module chunks = 23899280101116